import { render, staticRenderFns } from "./SelectGoodsReceipt.vue?vue&type=template&id=a2fd3656&"
import script from "./SelectGoodsReceipt.vue?vue&type=script&lang=js&"
export * from "./SelectGoodsReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports